export const navigateToUrl = url => {
  if (!url) {
    console.warn('URL is required for navigation');
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener noreferrer';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
